import { useDevice } from '@contexts/device';

import { TourListingCardProps } from '../TourListingCard/props';
import DesktopTourListingCard from './desktopListingCard';
import MobileTourListingCard from './mobileListingCard';

const NextTourListingCard = ({
  installments,
  fallBackImage,
  image,
  secure,
  name,
  promotion,
  originalPrice,
  sellingPrice,
  currency,
  discounted,
  boardType,
  discountRate,
  departureCityName,
  nightStay,
  dayStay,
  transportionTypeName,
  transportionTypeCode,
  dates,
  url,
  tourListing,
  features,
  images,
  discountType,
  seturExecutive,
  badge,
  gtmClick,
  rate,
  placesToGo,
  videos,
  nightCount,
  isTour,
  id,
  favoriteLists,
  refetchFavoriteLists,
  defaultList,
  defaultListItems,
  refetchDefaultList,
  segments,
  initialItem,
  badgeAnimation,
}: TourListingCardProps) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <DesktopTourListingCard
      badge={badge}
      badgeAnimation={badgeAnimation}
      seturExecutive={seturExecutive}
      tourListing={tourListing}
      installments={installments}
      name={name}
      image={image}
      boardType={boardType}
      nightCount={nightCount}
      isTour={isTour}
      discountRate={discountRate}
      discounted={discounted}
      originalPrice={originalPrice}
      sellingPrice={sellingPrice}
      discountType={discountType}
      rate={rate}
      currency={currency}
      secure={secure}
      departureCityName={departureCityName}
      features={features}
      placesToGo={placesToGo}
      nightStay={nightStay}
      dayStay={dayStay}
      url={url}
      transportionTypeName={transportionTypeName}
      transportionTypeCode={transportionTypeCode || ''}
      dates={dates}
      images={images}
      promotion={promotion}
      fallBackImage={fallBackImage}
      videos={videos ?? []}
      gtmClick={gtmClick}
      id={id}
      favoriteLists={favoriteLists}
      refetchFavoriteLists={refetchFavoriteLists}
      defaultList={defaultList}
      defaultListItems={defaultListItems}
      refetchDefaultList={refetchDefaultList}
      initialItem={initialItem}
      segments={segments}
    />
  ) : (
    <MobileTourListingCard
      badge={badge}
      seturExecutive={seturExecutive}
      tourListing={tourListing}
      badgeAnimation={badgeAnimation}
      installments={installments}
      name={name}
      image={image}
      boardType={boardType}
      nightCount={nightCount}
      isTour={isTour}
      discountRate={discountRate}
      discounted={discounted}
      originalPrice={originalPrice}
      sellingPrice={sellingPrice}
      discountType={discountType}
      rate={rate}
      currency={currency}
      secure={secure}
      departureCityName={departureCityName}
      features={features}
      placesToGo={placesToGo}
      nightStay={nightStay}
      dayStay={dayStay}
      url={url}
      transportionTypeName={transportionTypeName}
      transportionTypeCode={transportionTypeCode || ''}
      dates={dates}
      images={images}
      promotion={promotion}
      fallBackImage={fallBackImage}
      videos={videos ?? []}
      gtmClick={gtmClick}
      id={id}
      favoriteLists={favoriteLists}
      refetchFavoriteLists={refetchFavoriteLists}
      defaultList={defaultList}
      defaultListItems={defaultListItems}
      refetchDefaultList={refetchDefaultList}
      initialItem={initialItem}
      segments={segments}
    />
  );
};

export default NextTourListingCard;
